<template>
  <div id="app" :class="{ 'hide-menu': !isMenuVisible || !user }">
    <div class="headerFixed">
    <Header title="PENTAGRO" :hideToggle="!user" :hideUserDropdown="!user" />
    <Navbar v-if="user" />
    </div>
    <!-- <Menu v-if="user" /> -->
    <!-- <Loading v-if="showWait || validatingToken" /> -->
    <Loading v-if="validatingToken" />
    <Content v-else />
    <!-- <Content v-else /> -->
    <div>
      <Footer class="footerFixed" />
    </div>
  </div>
</template>

<script>

import { getUrlBase } from "@/global";
import { validateToken } from "@/global";
import { mapState } from "vuex";
import Header from "@/components/template/Header";
import Navbar from "@/components/template/Navbar";
import Content from "@/components/template/Content";
import Footer from "@/components/template/Footer";
import Loading from "@/components/template/Loading";
export default {
  name: "App",
  components: { Header, Navbar, Content, Footer, Loading },
  computed: mapState(["isMenuVisible", "user", "xml"]),
  data: function () {
    return {
      validatingToken: true,
    };
  },
  methods: {
    //verificar token
    async checkToken() {
      this.validatingToken = true;
      const json = localStorage.getItem("userKey");
      const tk = localStorage.getItem("tk");
      const system = localStorage.getItem("system");
      const userData = JSON.parse(json);
      const xml = JSON.parse(localStorage.getItem("xml"));
      const tokenMaxTime = JSON.parse(localStorage.getItem("tokenMaxTime"));
      const unitName = localStorage.getItem("unitName");
      const scenarioName = xml && xml.name ? xml.name : "Não informado";

      this.$store.commit("setUser", null);
      this.$store.commit("setToken", null);
      this.$store.commit("setXML", null);
      this.$store.commit("setSystem", null);
      this.$store.commit("setUnitName", null);
      this.$store.commit("setScenarioName", "Não informado")

      if (!userData) {
        this.validatingToken = false;
        this.$router.push({ name: "auth" }).catch(()=>{});
        return;
      } 
      
      const res = await validateToken()
      
      if (res) {
        this.$store.commit("setUser", userData);
        this.$store.commit("setToken", tk);
        this.$store.commit("setXML", xml);
        this.$store.commit("setSystem", system);
        this.$store.commit("setTokenMaxTime", tokenMaxTime);
        this.$store.commit("setUnitName", unitName);
        this.$store.commit("setScenarioName", scenarioName);
        this.$store.commit("setScenarioOutdated", localStorage.getItem("scenarioOutdated") === "true");
        // if (this.$mq === "xs" || this.$mq === "sm") {
        //   this.$store.commit("toggleMenu", false);
        // }
      } else {
        console.log("Token expirado");
        this.$store.commit("setUser", null);
        this.$store.commit("setToken", null);
        this.$store.commit("setXML", null);
        this.$store.commit("system", null);
        this.$store.commit("setUnitName", null);
        this.$store.commit("setScenarioName", "Não informado");
        localStorage.removeItem("userKey");
        localStorage.removeItem("tk");
        localStorage.removeItem("xml");
        localStorage.removeItem("system");
        localStorage.removeItem("tokenMaxTime");
        localStorage.removeItem("unitName");
        this.$router.push({ name: "auth" }).catch(()=>{});
      }
      this.validatingToken = false;
    }
  },
  async created() {
    await getUrlBase();
    await this.checkToken();    
  },
};
</script>

<style>

#app > div {
  background-color: white;
}

@font-face {
  font-family: RBNo3.1;
  src: url(./fonts/RBNo3.1-Thin.otf);
}
@font-face {
  font-family: RBNo3.1;
  src: url(./fonts/RBNo3.1-ThinItalic.otf);
}
@font-face {
  font-family: RBNo3.1;
  src: url(./fonts/RBNo3.1-Bold.otf);
}  
@font-face {
  font-family: RBNo3.1;
  src: url(./fonts/RBNo3.1-BoldItalic.otf);
}
@font-face {
  font-family: RBNo3.1;
  src: url(./fonts/RBNo3.1-Light.otf);
}  
@font-face {
  font-family: RBNo3.1;
  src: url(./fonts/RBNo3.1-LightItalic.otf);
}


* {
  font-family: RBNo3.1, Arial, Helvetica, sans-serif;
  /* font-family: RBNo3.1, sans-serif, "Lato"; */
  /* font-weight: lighter; */
}

body {
  margin: 0;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  display: grid;
  grid-template-rows: 50px 45px 1fr 40px;
  /* grid-template-columns: 170px 1fr; */
  grid-template-columns: 1fr;
  grid-template-areas:
    "header"
    "navbar"
    "content"
    "footer";
}
#app.hide-menu {
  grid-template-areas:
    "header"
    "content"
    "content"
    "footer";
}

.headerFixed {
  position: fixed;
  top: 0px;
  z-index: 1;
  width: 100%;
}

.footerFixed {
  position: fixed;
  bottom: 0px;
  width: 100%;
  z-index: 1;
}

ul.dropdown-menu.show {
    background-color: white;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

.groupBtn img {
  cursor: pointer;
  height: 35px;
  width: 35px;
}

.noselect {
  -webkit-touch-callout: none;
    -webkit-user-select: none;
     -khtml-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

input.input-pentagro,
select.input-pentagro,
div.spinbutton-pentagro,
#app select,
#app input {
  border: 1px solid #ff5f00;
  border-radius: 3px;
}

input.input-pentagro:focus,
select.input-pentagro:focus,
#app select:focus,
#app input:focus {
  border: 1px solid #ff5f00;
  box-shadow: 0px 0px 5px #ff5f00;
  outline: none; 
}

div.spinbutton-pentagro.focus {
  border: 1px solid #ff5f00;
  box-shadow: 0px 0px 5px #ff5f00;
}

::-webkit-scrollbar-track {
    background-color: #F4F4F4;
}

::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background: #F4F4F4;
}

::-webkit-scrollbar-thumb {
    background: #00A39F;
    border-radius: 4px;
}

html::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
}

html {
    scrollbar-width: none;
}
</style>
